module.exports = __webpack_public_path__ + "pic/20.f873c936.png";